<template>
    <md-card>
        <md-card-header class="md-card-header-icon md-card-header-blue">
            <div class="card-icon">
                <font-awesome-icon class="md-icon" :icon="['fa', 'folder']"/>
            </div>
            <h4 class="title">Documents</h4>
        </md-card-header>
        <md-card-content>
            <div>
                <h6>Ajouter un document</h6>
                <form ref="site_document_plan_add" @submit.prevent="storeDocument">
                <div class="md-layout-item md-size-25">
                    <md-field class="md-invalid">
                        <label>Fichier</label>
                        <md-file name="file" @change="selectFile"
                                 accept=".pdf,.doc,.docx,.xls,.xlsx,.jpeg,.jpg,.gif,.png"></md-file>
                        <validation-error marge="ml-2" :errors="apiValidationErrors.file"/>
                    </md-field>
                </div>
                <md-button type="submit" class="md-icon-button md-raised md-success mt-3" :disabled="awaitingRequest">
                    <span class="leading-none font-medium">Ajouter</span>
                </md-button>
                </form>
            </div>

            <div>
                <h6 class="mt-3">Liste de documents pour cette intervention</h6>
                <ul>
                    <li v-for="(document, key) in documents" :key="key"><a :href="document.url" target="_blank">{{ document.name }}</a></li>
                </ul>
            </div>
        </md-card-content>
    </md-card>
</template>

<script>
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";

export default {
    name: "Documents",
    components: {
        ValidationError
    },
    mixins: [formMixin],
    props: {
        intervention: Object
    },
    data () {
        return {
            documents: [],
            file: null,
            awaitingRequest: false
        }
    },
    async mounted () {
        const { data } = await this.$store.dispatch('interventions/getDocuments', {
            id: this.intervention.id,
        })
        this.documents = data
    },
    methods: {
        async storeDocument() {
            this.resetApiValidation()
            if(this.file) {
                this.awaitingRequest = true
                let formData = new FormData()
                formData.append('file', this.file)
                try {
                    const { data } = await this.$store.dispatch('interventions/storeDocument', {
                        id: this.intervention.id,
                        file: formData
                    })
                    this.documents = data
                    await this.$store.dispatch("alerts/success", "Document ajouté")
                    this.awaitingRequest = false
                } catch (e) {
                    this.setApiValidation(e.response.data.errors)
                    this.awaitingRequest = false
                }
            } else {
                this.setApiValidation([{
                    detail: 'Le fichier est requis.',
                    source: { pointer: '/data/attributes/file' }
                }])
            }
        },
        selectFile(e) {
            this.file = e.target.files[0]
        },
    }

}
</script>

<style scoped>

</style>
